module.exports = __webpack_public_path__ + "img/ic_24_fitnessplan_time.9e7cd3b0.svg";